<template>
    <div id="sidebar">
        <div class="top">
            <div class="header">Principal</div>
            <router-link to="/" v-slot="{ href, navigate, isExactActive }">
                <a :href="href" @click="navigate">
                    <div class="link" :class="isExactActive && 'active'"><b-icon icon="house-door" /> <span class="title">Acasă</span></div>
                </a>
            </router-link>

            <router-link to="/search-page" v-slot="{ href, navigate, isExactActive }">
                <a :href="href" @click="navigate">
                    <div class="link" :class="isExactActive && 'active'">
                        <b-icon icon="search" /> <span class="title">Căutare</span>
                        <span v-if="searchQuery" class="search-query">{{ searchQuery }}</span>
                    </div>
                </a>
            </router-link>

            <router-link to="/search-history" v-slot="{ href, navigate, isExactActive }">
                <a :href="href" @click="navigate">
                    <div class="link" :class="isExactActive && 'active'"><b-icon icon="clock-history" /> <span class="title">Istoric căutări</span></div>
                </a>
            </router-link>

            <router-link to="/manual-import" v-slot="{ href, navigate, isExactActive }">
                <a :href="href" @click="navigate">
                    <div class="link" :class="isExactActive && 'active'">
                        <b-icon icon="upload" /> <span class="title">Import manual</span>
                    </div>
                </a>
            </router-link>

            <div class="header">Oferte</div>
            <router-link to="/saved-offers" v-slot="{ href, navigate, isExactActive }">
                <a :href="href" @click="navigate">
                    <div class="link" :class="isExactActive && 'active'"><b-icon icon="card-list" /> <span class="title">Oferte salvate</span></div>
                </a>
            </router-link>

            <router-link to="/current-offer" v-slot="{ href, navigate, isExactActive }">
                <a :href="href" @click="navigate">
                    <div class="link" :class="isExactActive && 'active'">
                        <b-icon icon="file-ruled" /> <span class="title">Oferta curentă</span>
                        <span class="badge badge-danger ml-2" v-if="workingOffer.offer.product_count">{{workingOffer.offer.product_count}}</span>
                    </div>
                </a>
            </router-link>

            <template v-if="editingOffers.length > 0">
                <div class="header small">Se editează:</div>

                <div v-for="offer in this.editingOffers" :key="offer.id" class="editing-offers">
                    <router-link
                            :to="`/offer/${offer.id}/edit`"
                            v-slot="{ href, navigate, isExactActive }"
                    >
                        <a :href="href" @click="navigate">
                            <div class="link" :class="isExactActive && 'active'">
                                <span class="metadata">#{{offer.id}}</span>
                                <span class="title" v-if="offer.extra_data && offer.extra_data.clientName">{{offer.extra_data.clientName}}</span>
                                <span class="title" v-else><i>(Client necunoscut)</i></span>
                                <span class="badge badge-danger ml-auto" v-if="offer.product_count">{{offer.product_count}}</span>
                            </div>
                        </a>
                    </router-link>
                </div>
            </template>

            <div class="header">Comenzi</div>
            <router-link to="/saved-orders" v-slot="{ href, navigate, isExactActive }">
                <a :href="href" @click="navigate">
                    <div class="link" :class="isExactActive && 'active'"><b-icon icon="cart4" /> <span class="title">Comenzi salvate</span></div>
                </a>
            </router-link>
            <a style="cursor: pointer;" @click="newOrder">
                <div class="link"><b-icon icon="cart-plus" /> <span class="title">Comandă nouă</span></div>
            </a>
            <template v-if="editingOrders.length > 0">
                <div class="header small">Se editează:</div>

                <div v-for="order in this.editingOrders" :key="order.id" class="editing-offers">
                    <router-link
                            :to="`/order/${order.id}/edit`"
                            v-slot="{ href, navigate, isExactActive }"
                    >
                        <a :href="href" @click="navigate">
                            <div class="link" :class="isExactActive && 'active'">
                                <span class="metadata">#{{order.id}}</span>
                                <span class="title" v-if="order.supplier_names">{{order.supplier_names}}</span>
                                <span class="title" v-else><i>(Furnizor necunoscut)</i></span>
                                <span class="badge badge-danger ml-auto" v-if="order.product_count">{{order.product_count}}</span>
                            </div>
                        </a>
                    </router-link>
                </div>
            </template>

        </div>

        <div class="spacer"></div>

        <div class="version">
          B2B Tendering, versiunea <strong>{{appVersion}}</strong>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import axios from "@/utils/axios-instance";
    import store from "@/store";

    export default {
        name: "Sidebar",
        data() {
            return {
                appVersion: process.env.VUE_APP_B2B_TENDERING_VER
            }
        },
        methods: {
            async newOrder() {
                let loader = this.$loading.show();

                let response = await axios.post(`order/new-order`);
                await store.dispatch('reloadEditingOrders');
                await this.$router.push(`/order/${response.data.id}/edit`);

                loader.hide();
            },
        },
        computed: {
            ...mapState(['searchQuery', 'workingOffer', 'editingOffers', 'editingOrders'])
        }
    }
</script>

<style scoped>
    #sidebar {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    #sidebar .spacer {
        flex-grow: 1;
    }

    .version {
        padding: 10px 20px;
        font-size: 0.6rem;
        color: darkgrey;
    }

    .header {
        padding: 10px 20px;
        color: #464646;
        font-weight: 600;
        font-size: 14px;
        background-color: #e6e6e6;

        border-top: 1px solid #d8d8d8;
        border-bottom: 1px solid #d8d8d8;
    }

    .header:first-child {
        border-top: none;
    }

    .header.small {
        font-size: 12px;
        padding: 5px 20px;
        border: none;
        background-color: #f2f2f2;
        margin-top: 0;
    }

    a:hover {
        color: initial;
        text-decoration: none;
    }

    .link {
        padding: 12px 20px;
        color: #292929;
        font-weight: 800;
        font-size: 15px;

        display: flex;
        align-items: center;
    }
    .link.active {
        background-color: #ececec;
    }
    .link:hover {
        background-color: #ececec;
    }
    .link .b-icon {
        font-size: 170%;
        color: #024A8C;
        width: 25px;
        height: 25px;
    }
    .link .title {
        margin-left: 15px;
    }

    .editing-offers .link .metadata {
        color: #024A8C;
        width: 25px;
    }

    .editing-offers .link {
        padding-top: 6px;
        padding-bottom: 6px;
        font-size: 13px;
    }

    .search-query {
        margin-left: 10px;
        color: #6F6F6F;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>